var allSounds = [];
var soundOn = true;
if (loadObject("soundOn") != null) {
    soundOn = loadObject("soundOn");
}


function enableSound() {
    soundOn = true;
    saveObject("soundOn", true);
}

function disableSound() {
    soundOn = false;
    saveObject("soundOn", false);
}

function toggleSound() {
    if (soundOn) {
        disableSound()
    } else {
        enableSound();
    }
}

function playSound(soundName) {
    if (!soundOn)
        return null;
    //returns soundID
    return allSounds[soundName].play();
}

function stopSound(soundName, id) {
    if (!soundOn)
        return null;

    if (id)
        allSounds[soundName].stop(id);
    else
        allSounds[soundName].stop();
}

function setVolume(soundName, volume) {
    if (!soundOn)
        return null;

    allSounds[soundName].volume(volume);
}

function setRate(soundName, rate) {
    if (!soundOn)
        return null;

    allSounds[soundName].rate(rate);
}

function fadeSound(soundName, from, to, duration, id) {
    if (!soundOn)
        return null;

    if (id)
        allSounds[soundName].fade(from, to, duration, id);
    else
        allSounds[soundName].fade(from, to, duration);
}
